
import React, { useEffect, useRef, useState } from 'react';
import style from './style.module.css';
import conditional from '../../utils/conditional';
import { Link } from 'react-router-dom';

const TabBar = props => {

    const tabs = [
        {
            icon: 'tab_home',
            path: '/'
        },
        {
            icon: 'tab_goals',
            path: '/goals'
        },
        {
            icon: 'tab_group',
            path: '/groups'
        },
        {
            icon: 'tab_nav',
            path: '/geo'
        },
        {
            icon: 'tab_badges',
            path: '/badges'
        },
        {
            icon: 'tab_settings',
            path: '/settings'
        }
    ];

    const ref = useRef();

    const [selected, setSelected] = useState(0);

    useEffect(() => {
        setTimeout(() => {
            props.history.push(tabs[selected].path)
        }, 10);
    }, [selected]);

    const tab = (tab, index) => {
        const className = conditional('tab', style, {
            selected: index === selected
            // selected: props.history.location.pathname === tab.path
        });


        return (
            <div className={className + ' h1'} onClick={() => setSelected(index)}>
                <div className={style.highlight} />
                <div className={style.icon} style={{ backgroundImage: `var(--appearance-${tab.icon || ''})` }}>
                    {/* <span className="material-icons">{tab.icon}</span> */}
                </div>
                {/* <span className="material-icons">{tab.icon}</span> */}
            </div>
        );
    };

    return (
        <div className={style.TabBar}>
            <div className={style.tabs} ref={ref}>
                {tabs.map(tab)}
            </div>
        </div>
    );

};

export default TabBar;
